var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
var IFrame = /** @class */ (function (_super) {
    __extends(IFrame, _super);
    function IFrame() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IFrame.prototype.mounted = function () {
        window.addEventListener("message", this.onMessage, false);
    };
    IFrame.prototype.destroyed = function () {
        window.removeEventListener("message", this.onMessage);
    };
    IFrame.prototype.onMessage = function (ev) {
        if (this.$refs.host.contentWindow !== ev.source)
            return;
        if (ev.data && ev.data.event === "resize") {
            this.resize();
        }
        else if (ev.data && ev.data.event === "redirect") {
            window.location.href = ev.data.payload;
        }
        else if (ev.data && ev.data.event === "setWindowTitle") {
            document.title = ev.data.payload;
        }
        else {
            window.$bus.$emit(ev.data.event, ev.data.payload);
        }
    };
    IFrame.prototype.resize = function () {
        var doc = this.$refs.host.contentWindow.document;
        var height = Math.max(doc.body.scrollHeight, doc.body.offsetHeight, doc.documentElement.offsetHeight);
        this.height = height + "px";
    };
    IFrame.prototype.reload = function () {
        this.$refs.host.contentWindow.location.reload();
    };
    __decorate([
        Prop({ type: String, required: true })
    ], IFrame.prototype, "src", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], IFrame.prototype, "fill", void 0);
    __decorate([
        Prop({ type: String })
    ], IFrame.prototype, "width", void 0);
    __decorate([
        Prop({ type: String })
    ], IFrame.prototype, "height", void 0);
    IFrame = __decorate([
        Component({
            name: "IFrame"
        })
    ], IFrame);
    return IFrame;
}(Vue));
export default IFrame;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/IFrame.vue
// module id = 795
// module chunks = 24